import { axiosInstance } from '../App'
import { SECURED_API_BASE } from './apiConfig'
import {
  ContractOperationLogDetailDTO,
  ContractOperationLogFilter,
  ContractOperationLogItemDTO,
  ContractOperationLogOptionsDTO,
} from '../dto/contractOperationLog/ContractOperationLogDTO'

const BASE = `${SECURED_API_BASE}/contract-operation-logs`

export function getContractOperationLogs(filter: ContractOperationLogFilter, offset: number, pageSize: number): Promise<ContractOperationLogItemDTO[]> {
  return axiosInstance.get(BASE, { params: { ...filter, offset, pageSize } }).then(r => r.data ?? [])
}

export function getContractOperationLogDetails(contractOperationLogId: number, offset: number, pageSize: number): Promise<ContractOperationLogDetailDTO[]> {
  return axiosInstance.get(`${BASE}/${contractOperationLogId}/details`, { params: { offset, pageSize } })
    .then(r => r.data ?? [])
}

export function getContractOperationLogOptions(): Promise<ContractOperationLogOptionsDTO> {
  return axiosInstance.get(`${BASE}/options`).then(r => r.data)
}
